import React, {useContext} from "react";
import {LanguageContext} from "../../context/LanguageContext";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";

const CompanyDataGrid = (props) => {
  const languageContext = useContext(LanguageContext);

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{paddingTop: 1}}>
      <Grid item xs={5} sm={4}>
        <Typography variant="subtitle1">{languageContext.dictionary[props.title] || props.title}</Typography>
      </Grid>
      <Grid item xs={7} sm={7}>
        <Typography variant="subtitle2">{props.value}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider/>
      </Grid>
    </Grid>
  );
};

CompanyDataGrid.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string
};

export default CompanyDataGrid;
